//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afeganistão",
  za: "África do Sul",
  al: "Albânia",
  de: "Alemanha",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguila",
  aq: "Antártida",
  ag: "Antígua e Barbuda",
  sa: "Arábia Saudita",
  dz: "Argélia",
  ar: "Argentina",
  am: "Armênia",
  aw: "Aruba",
  au: "Austrália",
  at: "Áustria",
  az: "Azerbaijão",
  bs: "Bahamas",
  bh: "Bahrein",
  bd: "Bangladesh",
  bb: "Barbados",
  be: "Bélgica",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermudas",
  by: "Bielorrússia",
  bo: "Bolívia",
  ba: "Bósnia e Herzegovina",
  bw: "Botsuana",
  br: "Brasil",
  bn: "Brunei",
  bg: "Bulgária",
  bf: "Burquina Faso",
  bi: "Burundi",
  bt: "Butão",
  cv: "Cabo Verde",
  cm: "Camarões",
  kh: "Camboja",
  ca: "Canadá",
  qa: "Catar",
  kz: "Cazaquistão",
  td: "Chade",
  cl: "Chile",
  cn: "China",
  cy: "Chipre",
  va: "Cidade do Vaticano",
  co: "Colômbia",
  km: "Comores",
  cd: "Congo - Kinshasa",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  ci: "Costa do Marfim",
  cr: "Costa Rica",
  hr: "Croácia",
  cu: "Cuba",
  cw: "Curaçao",
  dk: "Dinamarca",
  dj: "Djibuti",
  dm: "Dominica",
  eg: "Egito",
  sv: "El Salvador",
  ae: "Emirados Árabes Unidos",
  ec: "Equador",
  er: "Eritreia",
  sk: "Eslováquia",
  si: "Eslovênia",
  es: "Espanha",
  sz: "Essuatíni",
  us: "Estados Unidos",
  ee: "Estônia",
  et: "Etiópia",
  fj: "Fiji",
  ph: "Filipinas",
  fi: "Finlândia",
  fr: "França",
  ga: "Gabão",
  gm: "Gâmbia",
  gh: "Gana",
  ge: "Geórgia",
  gi: "Gibraltar",
  gd: "Granada",
  gr: "Grécia",
  gl: "Groenlândia",
  gp: "Guadalupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gy: "Guiana",
  gf: "Guiana Francesa",
  gn: "Guiné",
  gq: "Guiné Equatorial",
  gw: "Guiné-Bissau",
  ht: "Haiti",
  hn: "Honduras",
  hk: "Hong Kong, RAE da China",
  hu: "Hungria",
  ye: "Iêmen",
  bv: "Ilha Bouvet",
  cx: "Ilha Christmas",
  im: "Ilha de Man",
  nf: "Ilha Norfolk",
  ax: "Ilhas Aland",
  ky: "Ilhas Cayman",
  cc: "Ilhas Cocos (Keeling)",
  ck: "Ilhas Cook",
  fo: "Ilhas Faroe",
  gs: "Ilhas Geórgia do Sul e Sandwich do Sul",
  hm: "Ilhas Heard e McDonald",
  fk: "Ilhas Malvinas",
  mp: "Ilhas Marianas do Norte",
  mh: "Ilhas Marshall",
  um: "Ilhas Menores Distantes dos EUA",
  pn: "Ilhas Pitcairn",
  sb: "Ilhas Salomão",
  tc: "Ilhas Turcas e Caicos",
  vi: "Ilhas Virgens Americanas",
  vg: "Ilhas Virgens Britânicas",
  in: "Índia",
  id: "Indonésia",
  ir: "Irã",
  iq: "Iraque",
  ie: "Irlanda",
  is: "Islândia",
  il: "Israel",
  it: "Itália",
  jm: "Jamaica",
  jp: "Japão",
  je: "Jersey",
  jo: "Jordânia",
  kw: "Kuwait",
  la: "Laos",
  ls: "Lesoto",
  lv: "Letônia",
  lb: "Líbano",
  lr: "Libéria",
  ly: "Líbia",
  li: "Liechtenstein",
  lt: "Lituânia",
  lu: "Luxemburgo",
  mo: "Macau, RAE da China",
  mk: "Macedônia do Norte",
  mg: "Madagascar",
  my: "Malásia",
  mw: "Malaui",
  mv: "Maldivas",
  ml: "Mali",
  mt: "Malta",
  ma: "Marrocos",
  mq: "Martinica",
  mu: "Maurício",
  mr: "Mauritânia",
  yt: "Mayotte",
  mx: "México",
  mm: "Mianmar (Birmânia)",
  fm: "Micronésia",
  mz: "Moçambique",
  md: "Moldova",
  mc: "Mônaco",
  mn: "Mongólia",
  me: "Montenegro",
  ms: "Montserrat",
  na: "Namíbia",
  nr: "Nauru",
  np: "Nepal",
  ni: "Nicarágua",
  ne: "Níger",
  ng: "Nigéria",
  nu: "Niue",
  no: "Noruega",
  nc: "Nova Caledônia",
  nz: "Nova Zelândia",
  om: "Omã",
  nl: "Países Baixos",
  bq: "Países Baixos Caribenhos",
  pw: "Palau",
  pa: "Panamá",
  pg: "Papua-Nova Guiné",
  pk: "Paquistão",
  py: "Paraguai",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pl: "Polônia",
  pr: "Porto Rico",
  pt: "Portugal",
  ke: "Quênia",
  kg: "Quirguistão",
  ki: "Quiribati",
  gb: "Reino Unido",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  do: "República Dominicana",
  re: "Reunião",
  ro: "Romênia",
  rw: "Ruanda",
  ru: "Rússia",
  eh: "Saara Ocidental",
  ws: "Samoa",
  as: "Samoa Americana",
  sm: "San Marino",
  sh: "Santa Helena",
  lc: "Santa Lúcia",
  bl: "São Bartolomeu",
  kn: "São Cristóvão e Névis",
  mf: "São Martinho",
  pm: "São Pedro e Miquelão",
  st: "São Tomé e Príncipe",
  vc: "São Vicente e Granadinas",
  sc: "Seicheles",
  sn: "Senegal",
  sl: "Serra Leoa",
  rs: "Sérvia",
  sg: "Singapura",
  sx: "Sint Maarten",
  sy: "Síria",
  so: "Somália",
  lk: "Sri Lanka",
  sd: "Sudão",
  ss: "Sudão do Sul",
  se: "Suécia",
  ch: "Suíça",
  sr: "Suriname",
  sj: "Svalbard e Jan Mayen",
  tj: "Tadjiquistão",
  th: "Tailândia",
  tw: "Taiwan",
  tz: "Tanzânia",
  cz: "Tchéquia",
  io: "Território Britânico do Oceano Índico",
  tf: "Territórios Franceses do Sul",
  ps: "Territórios palestinos",
  tl: "Timor-Leste",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad e Tobago",
  tn: "Tunísia",
  tm: "Turcomenistão",
  tr: "Turquia",
  tv: "Tuvalu",
  ua: "Ucrânia",
  ug: "Uganda",
  uy: "Uruguai",
  uz: "Uzbequistão",
  vu: "Vanuatu",
  ve: "Venezuela",
  vn: "Vietnã",
  wf: "Wallis e Futuna",
  zm: "Zâmbia",
  zw: "Zimbábue",
};
